module.exports = __webpack_public_path__ + "media/images/lb/765-6cf1b6dbb662f953b0b57a18a2617176.svg";